import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import Table from "./OccupierCompanyTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { clientAccess } from "../../utils/index";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import Select from "react-select";
import { Redirect, withRouter, Link } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class OccupierCompanyDetails extends React.Component {
  state = {
    id: undefined,
    occupierGroups: [],
    clientGroups: [],
    clientList: [],
    popupContent: "",
    messsagePopup: false,
    delete: false,
    companyName: [],
    companyId: "",
    companyCode: "",
    companyPan: "",
    vendorCode: "",
    companyTan: "",
    companyType: "",
    groupId: "",
    isOpen: false,
    redirect: false,
    url: `${apiUrl.apiUrl.url}/occupier/create`,
    initialValues: {
      cgroupId: "",
      cgroupName: "",
      clientId: "",
      clientName: "",
      companyName: "",
      companyId: "",
      companyType: "",
      companyPan: "",
      companyTan: "",
      groupId: "",
      groupName: "",
      vendorCode: "",
      tenantSector: ""
    },
  };
  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          clientGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    //fetch(`${apiUrl.apiUrl.url}/occupier-groups`)
    fetch(`${apiUrl.apiUrl.url}/occupier-group/fetch-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          occupierGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  changeGroup = (e) => {
    let groupid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/occupier/get-group-companies/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyName: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  changeCompany = (e) => {
    let groupid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/occupier/get-company/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyId: data.company_code,
          companyCode: data.company_code,
          companyType: data.company_type,
          companyTan: data.company_tan,
          companyPan: data.company_pan,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  constructor(props) {
    super(props);
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/occupier/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this item"
        });

      } else {
        self.setState({
          delete: true
        });
      }

    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/occupier/create`,
          initialValues: {
            cgroupId: "",
            cgroupName: "",
            clientId: "",
            clientName: "",
            companyName: "",
            companyId: "",
            companyType: "",
            companyPan: "",
            companyTan: "",
            groupName: "",
            groupId: "",
          },
        });
      } else {
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/occupier/get-company/?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/occupier/update?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            clientGroups: data.clientGroups,
            clientList: data.clientList,
          });
        }).catch((error)=>{
          
        });

        // fetch(
        //   `${apiUrl.apiUrl.url}/occupier/get-company/?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/occupier/update?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       clientGroups: data.clientGroups,
        //       clientList: data.clientList,
        //     });
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }

  handleChangeOccupierGroup = (newValue, actionMeta) => {
    console.group(newValue, "Value Changed");
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.groupEnd();
  };
  handleChangeclientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.cgroupId = newValue.value;
      this.state.initialValues.cgroupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.cgroupId = newValue;
    console.log(this.cgroupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/occupier/delete?id=${this.state.id}`,
    }).then(function (response) {

      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",

        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        cgroupId: "",
        cgroupName: "",
        clientId: "",
        clientName: "",
        companyName: "",
        companyId: "",
        companyType: "",
        companyPan: "",
        companyTan: "",
        groupName: "",
        groupId: "",
      },
    });
  };
  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        cgroupId: "",
        cgroupName: "",
        clientId: "",
        clientName: "",
        companyName: "",
        companyId: "",
        companyType: "",
        companyPan: "",
        companyTan: "",
        groupName: "",
        groupId: "",
      },
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/occupier-company-details" />;
    }

    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/occupier-directory">Occupier Directory</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Occupier Company Details</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            // alert(JSON.stringify(values, null, 2));
            values.groupId = this.state.initialValues.groupId;
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!"
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>

              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Group <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientGroup"
                              onChange={(e) => {
                                this.handleChangeclientGroup(e, "change_client_group");
                              }}
                              value={{
                                label: this.state.initialValues.cgroupName,
                                value: this.state.initialValues.cgroupId,
                              }}
                              options={this.state.clientGroups.map((item) => ({
                                label: item.group_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="clientGroup"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientName"
                              onChange={(e) => {
                                this.handleChangeclientGroup(e, "change_client_name");
                              }}
                              value={{
                                label: this.state.initialValues.clientName,
                                value: this.state.initialValues.clientId,
                              }}
                              options={this.state.clientList.map((item) => ({
                                label: item.client_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="clientName"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      <div className="newGridSectionInner">
                        <label>
                          Occupier Group <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <CreatableSelect
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="groupId"
                            onChange={(e) => {
                              this.handleChangeOccupierGroup(e);
                            }}
                            value={{
                              label: this.state.initialValues.groupName,
                              value: this.state.initialValues.groupId,
                            }}
                            options={this.state.occupierGroups.map((item) => ({
                              label: item.group_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="groupId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Occupier Company Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="companyName" />
                          <ErrorMessage
                            name="companyName"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Company ID
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="companyCode"
                            readOnly
                            onChange={(e) => {
                              this.setState({ companyCode: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage
                            name="companyId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Company Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="companyType"
                            onChange={(e) => {
                              this.setState({ companyType: e.target.value });
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="Limited Company">Limited Company</option>
                            <option value="Private Limited Company">Private Limited Company</option>
                            <option value="Limited Liability Partnership">Limited Liability Partnership</option>
                            <option value="Partnership">Partnership</option>
                            <option value="Sole Proprietor">Sole Proprietor</option>
                            <option value="Proprietorship">Proprietorship</option>
                            <option value="Hindu Undivided Family">Hindu Undivided Family</option>
                            <option value="Individual">Individual</option>
                            <option value="One Person Company (OPC)">One Person Company (OPC)</option>
                            <option value="Non Government Organization">Non Government Organization</option>
                          </Field>
                          <ErrorMessage
                            name="companyType"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          PAN Number
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="companyPan"
                            onChange={(e) => {
                              this.setState({ companyPan: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage
                            name="companyPan"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          TAN Number
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="companyTan"
                            onChange={(e) => {
                              this.setState({ companyTan: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage
                            name="companyTan"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Vendor Code
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="vendorCode"
                            onChange={(e) => {
                              this.setState({ vendorCode: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage
                            name="vendorCode"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Tenant Sector
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="tenantSector"
                            onChange={(e) => {
                              this.setState({ tenantSector: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage
                            name="tenantSector"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}>
                          Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          <Link to="/masters/occupier-company-details">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}

                  </div>
                </Form>
              </div>


              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      {clientAccess() &&
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Group <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">

                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="clientGroup"
                                  //onInputChange={this.handleChange}
                                  onChange={(e) => {
                                    this.handleChangeclientGroup(
                                      e,
                                      "change_client_group"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.cgroupName,
                                    value: this.state.initialValues.cgroupId,
                                  }}
                                  options={this.state.clientGroups.map(
                                    (item) => ({
                                      label: item.group_name,
                                      value: item.id,
                                    })
                                  )}
                                />

                                <ErrorMessage
                                  name="clientGroup"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>}
                      {clientAccess() &&
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Name <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="clientName"
                                  onChange={(e) => {
                                    this.handleChangeclientGroup(
                                      e,
                                      "change_client_name"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.clientName,
                                    value: this.state.initialValues.clientId,
                                  }}
                                  options={this.state.clientList.map((item) => ({
                                    label: item.client_name,
                                    value: item.id,
                                  }))}
                                />
                                <ErrorMessage
                                  name="clientName"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>}
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Occupier Group <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <CreatableSelect
                                name="groupId"
                                onChange={(e) => {
                                  this.handleChangeOccupierGroup(e);
                                }}
                                value={{
                                  label: this.state.initialValues.groupName,
                                  value: this.state.initialValues.groupId,
                                }}
                                options={this.state.occupierGroups.map(
                                  (item) => ({
                                    label: item.group_name,
                                    value: item.id,
                                  })
                                )}
                              />
                              <ErrorMessage
                                name="groupId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                            <div className="col-sm-1 btnAddContainer">
                            <FontAwesomeIcon
                              icon={faPlus}
                              className="btnAdd"
                              onClick={this.openModal}
                            />
                          </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Occupier Company Name{" "}
                              <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="companyName" />
                              <ErrorMessage
                                name="companyName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Company ID
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="companyCode"
                                readonly="readonly"
                                onChange={(e) => {
                                  this.setState({ companyCode: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="companyId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Company Type <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="companyType"
                                onChange={(e) => {
                                  this.setState({ companyType: e.target.value });
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option
                                  value="Limited Company"
                                  label="Limited Company"
                                />
                                <option
                                  value="Private Limited Company"
                                  label="Private Limited Company"
                                />
                                <option
                                  value="Limited Liability Partnership"
                                  label="Limited Liability Partnership"
                                />
                                <option value="Partnership" label="Partnership" />
                                <option
                                  value="Sole Proprietor"
                                  label="Sole Proprietor"
                                />
                                <option
                                  value="Proprietorship"
                                  label="Proprietorship"
                                />
                                <option
                                  value="Hindu Undivided Family"
                                  label="Hindu Undivided Family"
                                />
                                <option value="Individual" label="Individual" />
                                <option
                                  value="One Person Company (OPC)"
                                  label="One Person Company (OPC)"
                                />
                                <option
                                  value="Non Government Organization"
                                  label="Non Government Organization"
                                />
                              </Field>
                              <ErrorMessage
                                name="companyType"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              PAN Number
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="companyPan"
                                onChange={(e) => {
                                  this.setState({ companyPan: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="companyPan"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              TAN Number
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="companyTan"
                                onChange={(e) => {
                                  this.setState({ companyTan: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="companyTan"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Vendor Code
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="vendorCode"
                                // value={this.state.companyTan}
                                onChange={(e) => {
                                  this.setState({ vendorCode: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="vendorCode"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Tenant Sector
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="tenantSector"
                                // value={this.state.companyTan}
                                onChange={(e) => {
                                  this.setState({ tenantSector: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="tenantSector"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                <Link to="/masters/occupier-company-details">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Add
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Table />
      </>
    );
  }
}

export default withRouter(OccupierCompanyDetails);
